module.exports = __webpack_public_path__ + "static/media/twitter.7bc154c9.svg";